module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter_hd"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/06introduction#int",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/06introduction#int",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg12lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devices for Creative Swearing")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg12lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg14lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devices for Creative Swearing")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg14lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg16lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swear Words Ranked by Severity from MOST to LEAST likely to Offend")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg16lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg18lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief History of Blasphemy")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg18lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg20lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building an Effective Insult")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg20lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order of Adjectives in Insults")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07introduction1#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Fuck")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology of Fuck")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg30lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuck as an Adjective, Verb, Noun, and Grammatical Ejaculation")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg30lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Correct use of Fucking as an Infix")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Correct Use of Fuck as an Intensifier")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conjugation of Fuck")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acceptability of Fuck and Fuck Derivatives")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg40lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motherfucker as an Adjective and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg40lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg42lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fucking Senses")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg42lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg43lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fucking Tenses")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg43lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passive")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg45lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aggressive")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg45lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg46lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The F Word")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01a#pg46lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Shit")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg60lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg60lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg62lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punctuation")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg62lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg64lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shit as an Adjective, Verb, and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg64lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good shit")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg67lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bad shit")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg67lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg68lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animal Shit")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg68lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg69lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tenses")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02a#pg69lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Piss")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("78")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg82lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg82lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg84lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piss as an Adjective, Verb, and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg84lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Context")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg88lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tenses")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg88lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg90lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg90lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg91lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hard")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter03a#pg91lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Bollocks")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("100")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg104lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg104lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg106lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bollocks as an Interjection, Verb, and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg106lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg108lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg108lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg109lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bad")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg109lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg110lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excellent")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg110lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg112lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breasticles and Testicles")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg112lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg112lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg112lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg112lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("’ers")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg112lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spheres")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Receptacles")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nonsense")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Polite/Medical")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg113lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg114lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bullshit or Bollocks?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter04a#pg114lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(" Ass")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("124")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter05a#pg128lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter05a#pg128lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter05a#pg130lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ass as an Adjective, Verb, and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter05a#pg130lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Dick")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("142")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter06a#pg146lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dick as a Verb and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter06a#pg146lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("146")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter06a#pg148lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter06a#pg148lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Cunt")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("152")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg156lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cunt as an Adjective, Verb, and Noun")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg156lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg158lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Etymology")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg158lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("158")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg160lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genitals in the Strongest Terms")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg160lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mild")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strong")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strongest")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg161lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg164lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Derivations")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter07a#pg164lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v(" Polite Swears")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("166")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v(" Hand Gestures")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("178")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter09a#pg182lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Middle finger")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter09a#pg182lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("182")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter09a#pg184lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two fingers")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter09a#pg184lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("184")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter09a#pg186lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wanker")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter09a#pg186lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("186")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26appendix1#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26appendix1#app",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('em', [_vm._v("188")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26appendix1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1 A list of the most commonly used words")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26appendix1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("188")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27appendix2#app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2 Getting it wrong")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/27appendix2#app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/28acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("192")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("192")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2c9a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05toc.vue
// module id = 69
// module chunks = 0